"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORGANISATION_PACKAGE_CREDIT_TYPE = void 0;
var ORGANISATION_PACKAGE_CREDIT_TYPE = {
  TEAM: 'TEAM',
  SHARE: 'SHARE'
};
exports.ORGANISATION_PACKAGE_CREDIT_TYPE = ORGANISATION_PACKAGE_CREDIT_TYPE;